module.exports = __webpack_public_path__ + "static/img/major_pictgrid38_1080x843.bc1feac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid38_1080x843.jpg
// module id = Qk3E
// module chunks = 0